<template>
  <span class="artwork-prompt-help">
    <i
      :id="id"
      class="fa fa-question-circle text-info ml-1"
      tabindex="0"
      role="button"
      aria-label="Como posicionar o QR Code e as logos"
    ></i>
    <b-popover :target="id" triggers="hover focus" placement="right" custom-class="artwork-help-popover">
      <template #title>Posição do QR Code e das logos</template>
      <ul class="pl-3 mb-2">
        <li>
          Escreva no prompt onde quer o <strong>QR Code</strong> e a <strong>faixa de logos</strong>:
          topo, meio ou rodapé; esquerda, centro ou direita. Ex.: "QR grande no centro, logos no rodapé".
        </li>
        <li>Tamanho: pequeno, médio ou grande.</li>
        <li>Sem indicação: QR no canto inferior direito e logos no topo.</li>
        <li>As logos ficam juntas numa faixa. Quais entram, você escolhe nos checkboxes abaixo do prompt.</li>
        <li>
          <strong>Arte base</strong>: anexe uma arte que você já tem (PNG, JPEG ou WEBP) e a IA cria uma
          arte nova no mesmo estilo (cores, fontes, ilustração), com o conteúdo do prompt e na mesma
          proporção.
        </li>
      </ul>
      <small class="text-muted">
        A posição é aproximada: o QR pode subir ou descer um pouco para não cobrir textos da arte.
        Textos e ilustração são criados pela IA e podem variar a cada geração.      </small>
    </b-popover>
  </span>
</template>

<script>
let uid = 0;

// Ícone de ajuda (popover) sobre como pedir a posição do QR Code e das logos no prompt da arte.
export default {
  name: "ArtworkPromptHelp",
  data() {
    uid += 1;
    return { id: "artwork-prompt-help-" + uid };
  },
};
</script>

<style>
.artwork-help-popover {
  max-width: 340px;
  font-size: 0.8rem;
}
</style>
